module.exports = __webpack_public_path__ + "img/portrait-022.b3130304.jpg";